module.exports = __webpack_public_path__ + "static/DSC_9304-96efd761405251c614cb887412380859.jpg";